import { axios } from '@/utils/request'

export function getVacancies (parameter) {
    return axios({
        url: '/vacancies/',
        method: 'get',
        params: parameter
    })
}
